import { useState } from 'react';
import { Loader2 } from 'lucide-react';

interface WaitlistSignUpFormProps {
  onSuccess: () => void;
}

export default function WaitlistSignUpForm({ onSuccess }: WaitlistSignUpFormProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // const formData = new FormData(e.currentTarget);
    // const data = {
    //   email: formData.get('email'),
    //   name: formData.get('name'),
    //   role: formData.get('role')
    // };

    try {
      // TODO: Implement API call to save waitlist signup
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulated API call
      onSuccess();
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
          Full Name
        </label>
        <input
          type="text"
          name="name"
          id="name"
          required
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
          placeholder="Enter your full name"
        />
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
          Email
        </label>
        <input
          type="email"
          name="email"
          id="email"
          required
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
          placeholder="Enter your email"
        />
      </div>

      <div>
        <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1">
          I am a...
        </label>
        <select
          name="role"
          id="role"
          required
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
        >
          <option value="">Select your role</option>
          <option value="student">Student</option>
          <option value="parent">Parent</option>
          <option value="teacher">Teacher</option>
          <option value="other">Other</option>
        </select>
      </div>

      {error && (
        <p className="text-red-500 text-sm opacity-0 animate-fade-in">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={isLoading}
        className="w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? (
          <span className="flex items-center justify-center gap-2">
            <Loader2 className="w-5 h-5 animate-spin" />
            Joining Waitlist...
          </span>
        ) : (
          'Join Waitlist'
        )}
      </button>
    </form>
  );
} 